import './App.css';
import { Fragment, useEffect, useState } from 'react';
import NavBar from './Components/NavBar';
import About from './Components/About';
import Work from './Components/Work';
import Certifications from './Components/Certifications';
import Skills from './Components/Skills';
import Contact from './Components/Contact';

function App() {
  const [theme, setTheme] = useState('dark');

  useEffect(() => {
    const storedTheme = window.localStorage.getItem('theme');
    if (storedTheme === 'light' || storedTheme === 'dark') {
      setTheme(storedTheme);
      return;
    }

    const prefersLight = window.matchMedia('(prefers-color-scheme: light)').matches;
    setTheme(prefersLight ? 'light' : 'dark');
  }, []);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    window.localStorage.setItem('theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prevTheme) => (prevTheme === 'dark' ? 'light' : 'dark'));
  };

  return (
    <Fragment>
      <NavBar theme={theme} onToggleTheme={toggleTheme} />
      <main className="site-shell">
        <About />
        <Work />
        <Certifications />
        <Skills />
        <Contact />
      </main>
    </Fragment>
  );
}

export default App;
